import React from 'react';
import {Route, Switch} from 'react-router-dom';

import HomePage from 'pages/HomePage';

import DesignerPage from 'pages/DesignerPage';

import AllStoresPage from 'pages/AllStoresPage';
import AllArtistPage from 'pages/AllArtistPage';
import StorePage from 'pages/StorePage';

import SubmitDesignPage from 'pages/SubmitDesignPage';
import AddSubProductPage from 'pages/products/AddSubProductPage';

import LogoutPage from 'pages/LogoutPage';
import AccountVerificationPage from 'pages/AccountVerificationPage';
import ChangePasswordPage from 'pages/ChangePasswordPage';

import DesignerDashboardPage from 'pages/DesignerDashboardPage';
import DiscountedProductsPage from 'pages/DiscountedProductsPage';

import ProductDetailPage from 'pages/ProductDetailPage';

import OrdersDashboardPage from 'pages/admin/OrdersDashboardPage';
import MyOrdersPage from 'pages/MyOrdersPage';

import RedeemHistoryPage from 'pages/RedeemHistoryPage';

import ProductsDashboardPage from 'pages/admin/ProductsDashboardPage';

import UserSettingsPage from 'pages/UserSettingsPage';
import OrderSettingsPage from 'pages/OrderSettingsPage';

import ProductsByTagPage from 'pages/ProductsByTagPage';
import ProductsByTypePage from 'pages/ProductsByTypePage';

import _404 from 'pages/404';
import _401 from 'pages/401';
import AnalyticsOptOutPage from 'pages/AnalyticsOptOutPage';

import AgreementsPage from 'pages/docs/AgreementsPage';
import HowToMakeMoney from 'pages/docs/HowToMakeMoney';
import HowMuchCanIMake from 'pages/docs/HowMuchCanIMake';
import FAQ from 'pages/docs/FAQ';

import DashainFramePage from 'pages/campaigns/DashainFrame';
import BuyOneDonateOne from 'pages/campaigns/BuyOneDonateOne';

import StockDashboardPage from 'pages/admin/StockDashboardPage';

import SearchResultPage from 'pages/SearchResultPage';

import AppUtil from 'AppUtil';
import AppConstants from 'AppConstants';
import MusicPlaqueMaker from './pages/MusicPlaqueMaker';
import PhotoFramePage from './pages/products/PhotoFramePage';
import ChetanCamper from './pages/campaigns/ChetanCamper';
import CodersCampaign from './pages/campaigns/CodersCampaign';
import NepalThemeMerch from './pages/campaigns/NepalThemeMerch';

import CheckoutPage from 'pages/CheckoutPage';
import HGADesignCampaign from './pages/campaigns/HGADesignCampaign';

import AccountDeactivatePage from './pages/AccountDeactivatePage';
import ArtistRegisterPage from './pages/ArtistRegisterPage';

import AllUsersDashboardPage from 'pages/admin/AllUsersDashboardPage';

const PRODUCT_URLS = Object.keys(AppConstants.PRODUCT_TYPES).map(k => AppConstants.PRODUCT_TYPES[k].url).join("|");

const AppRouter = () => {
      AppUtil.scrollToTop();
	return <Switch>
      		<Route exact path="/" component={HomePage} />
      		<Route exact path="/logout" component={LogoutPage} />
                  <Route exact path="/user/change-password/:token" component={ChangePasswordPage} />
                  <Route exact path="/user/verify/:token" component={AccountVerificationPage} />

                  <Route exact path="/designer/:userId/dashboard" component={DesignerDashboardPage} />
                  <Route exact path="/designer/dashboard" component={DesignerDashboardPage} />

                  <Route exact path="/designer/:userId/coupons" component={DiscountedProductsPage} />
                  <Route exact path="/designer/coupons" component={DiscountedProductsPage} />

                  <Route path="/designer/:designerName/:userId" component={DesignerPage} />
                  <Route path="/photographer/:designerName/:userId" component={DesignerPage} />
                  <Route path="/fashion-designer/:designerName/:userId" component={DesignerPage} />

                  <Route path="/store/:storeName" component={StorePage} />
                  
                  <Route path="/artist/signup" component={ArtistRegisterPage} />
                  <Route path="/artist/all" component={AllArtistPage} />
                  <Route path="/artist/browse/:prefix" component={AllArtistPage} />
                  <Route path="/stores/all" component={AllStoresPage} />
                  <Route path="/stores/:storeName" component={StorePage} />
                  
      		
                  
      		<Route exact path="/design/submit" component={SubmitDesignPage} />
                  <Route exact path={"/custom-order/music-plaque"} component={MusicPlaqueMaker} />
                  <Route exact path={"/custom-order/photo-frame"} component={PhotoFramePage} />

                  //Added name in the url for SEO purpose only
                  
                  <Route exact path={"/("+PRODUCT_URLS+")/edit/:name/:productId"} component={ProductDetailPage} />
                  <Route exact path={"/("+PRODUCT_URLS+")/addSub/:name/:productId"} component={AddSubProductPage} />
      		<Route path={"/("+PRODUCT_URLS+")/:name/:productId"} component={ProductDetailPage} />
                  <Route path={"/shop/:name/:productId"} component={ProductDetailPage} />
                  

                  <Route exact path="/order/dashboard" component={OrdersDashboardPage} />
                  <Route exact path="/orders" component={MyOrdersPage} />
                  <Route exact path="/orders/checkout" component={CheckoutPage} />
                  <Route exact path="/order/:orderId/settings" component={OrderSettingsPage} />

                  <Route exact path="/settings" component={UserSettingsPage} />
                  <Route exact path="/:userId/settings" component={UserSettingsPage} />


                  <Route exact path="/product/dashboard" component={ProductsDashboardPage} />

                  <Route exact path="/tag/:tagName" component={ProductsByTagPage} />
                  <Route exact path={"/shop/("+PRODUCT_URLS+")"} component={ProductsByTypePage} />
                  <Route exact path="/search" component={SearchResultPage} />
                  <Route exact path="/search/:keyword" component={SearchResultPage} />
                  
                  <Route exact path="/withdrawals" component={RedeemHistoryPage} />

      		<Route exact path="/401" component={_401} />
                  <Route exact path="/404" component={_404} />

                  <Route exact path="/terms-of-use-and-privacy-policy" component={AgreementsPage} />
                  <Route exact path="/how-to-make-money" component={HowToMakeMoney} />

                  <Route exact path="/how-much-can-i-make" component={HowMuchCanIMake} />
                  <Route exact path="/faq" component={FAQ} />

                  <Route exact path="/analytics/optout" component={AnalyticsOptOutPage} />
                  
                  

                  <Route exact path="/stock/dashboard" component={StockDashboardPage} />
                  <Route exact path="/stock/:stockOwner" component={StockDashboardPage} />

                  <Route exact path="/dashain/photoframe" component={DashainFramePage} />
                  <Route exact path="/coders-merch" component={CodersCampaign} />

                  <Route exact path="/nepal-merch" component={NepalThemeMerch} />
                  
                  <Route exact path="/chetan-vlog-camper" component={ChetanCamper} />
                  <Route exact path="/dashain/buyonedonateone" component={BuyOneDonateOne} />
                  <Route exact path="/dashain/buy-one-donate-one" component={BuyOneDonateOne} />

                  <Route exact path="/high-ground-adventure-design" component={HGADesignCampaign} />

                  <Route exact path="/deactivate" component={AccountDeactivatePage} />
                  <Route exact path="/deactivate/:userId" component={AccountDeactivatePage} />
                  
                  <Route exact path="/all-users/dashboard" component={AllUsersDashboardPage} />
                  <Route component={_404} />
      	</Switch>
};

export default AppRouter;




// WEBPACK FOOTER //
// ./src/AppRouter.js